import React, { Component } from 'react';
import {jsonUrl} from '../components/Factory' 
import Team from '../components/Team'; 

class TeamContainer extends Component {
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	
		setTimeout(function(){
			document.getElementById('menu-informationen').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('menu-informationen').classList.remove('active');
	}
	render() {		   
		   const { teamList,teamPage } = this.props.resolves;
		   return (
				<Team left={teamPage.title_left} right={teamPage.title_right} items={teamList} /> 
			)
	   
	}
}
export function getTeamPage(){
	return fetch(jsonUrl({ 
						number:1,
						type:'pages',
						slug:"team",						
					}))
				  .then(res => res.json())
				  .then(res => {
					document.title = res[0].yoast.title
					return res[0];		 
				  })
}
export function getTeamList(){
	return fetch(jsonUrl({ 
						number:100,
						type:'team',
						orderbymeta:'menu_order',
						order:'asc'
					}))
				  .then(res => res.json())
				  .then(res => {
					return res;		 
				  })
}
export default TeamContainer;


// WEBPACK FOOTER //
// ./src/containers/TeamContainer.js